import "./App.css";
import Header from "./components/header";
import "bootstrap/dist/css/bootstrap.min.css";
import Principal from "./components/principal";
import ContactoComponent from "./components/contacto";
import Footer from "./components/footer";

import Servicios from "./components/servicios";
import Menu from "./components/menu";

function App() {
  return (
    <div className="App">
      <Header />

      <main>
        <div id="inicio">
          <Principal />
        </div>
        <div id="menu">
          {" "}
          <Menu />
        </div>

        <div id="servicios">
          {" "}
          <Servicios />{" "}
        </div>

        <div id="contacto">
          <ContactoComponent />
        </div>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
